(() => {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const data = JSON.parse($('#zp-page-data').textContent);
  const labels = data.labels;
  const rootUrl = (window.Shopify?.routes?.root || data.root || '/').replace(/\/?$/, '/');
  const sectionState = new WeakMap();
  const cartDialog = $('#zp-cart');
  const desktop = matchMedia('(min-width:990px)');
  let lastCart;
  let cartBusy = false;
  let cartRevision = 0;
  const announce = message => { $('#zp-live-status').textContent = message; };
  const money = (cents, currency) => {
    const code = currency || data.currency;
    if (code === 'EUR') return new Intl.NumberFormat('lt-LT', {minimumFractionDigits:2, maximumFractionDigits:2}).format(cents / 100) + '\u00a0€';
    return new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency', currency:code}).format(cents / 100);
  };
  const showDialog = dialog => { if (dialog && !dialog.open) dialog.showModal(); };
  async function request(path, body) {
    const response = await fetch(rootUrl + path, {method: body ? 'POST' : 'GET', credentials: 'same-origin', headers: body ? {'Content-Type': 'application/json', Accept: 'application/json'} : {Accept: 'application/json'}, ...(body ? {body: JSON.stringify(body)} : {})});
    const result = await response.json();
    if (!response.ok) throw new Error(result.description || result.message || labels.error);
    return result;
  }
  function cartError(error) { const node = $('#zp-cart-error'); node.hidden = false; node.textContent = error.message || labels.error; }
  function renderCart(cart) {
    lastCart = cart;
    renderStyledCart(cart);
  }
  function desktopMoney(cents, currency, withCode = false) {
    const code = currency || data.currency;
    const value = money(cents, code);
    return value + (withCode && code !== 'EUR' ? ' ' + code : '');
  }
  function renderStyledCart(cart) {
    const content = $('#zp-cart-content');content.replaceChildren();
    cartDialog.classList.toggle('zp-cart-empty', !cart.items.length);
    $('#zp-cart-heading').textContent = cart.items.length ? data.cart_heading : labels.empty;
    let savings = 0;
    if (!cart.items.length) {
      const text = document.createElement('p');text.className = 'zp-empty-message';text.textContent = labels.empty_message;content.append(text);
      const offer = $('.draft-bundle img');
      if (offer) {const image = offer.cloneNode();image.className='zp-empty-image';image.loading='eager';content.append(image);}
      const title = document.createElement('h3');title.textContent=data.product.title;content.append(title);
      const price = document.createElement('p');price.className='zp-empty-price';price.textContent=desktopMoney(data.product.variants[0].price,cart.currency);content.append(price);
      const button = document.createElement('button');button.className='zp-cart-shop';button.type='button';button.textContent=labels.shop_now;button.addEventListener('click',()=>{cartDialog.close();$('#product-top')?.scrollIntoView({behavior:'smooth'});});content.append(button);
    }
    cart.items.forEach(item => {
      const row = document.createElement('div');row.className='draft-cart-line';
      const offer = $('[data-zp-card-price="' + item.variant_id + '"]')?.closest('.draft-bundle')?.querySelector('img');
      if (item.image || offer) {const image=document.createElement('img');image.src=offer ? offer.currentSrc || offer.src : item.image;image.alt=item.product_title;image.width=110;image.height=110;row.append(image);}
      const detail=document.createElement('div');
      const review=$('.custom_pdp_review');
      if (item.product_id === data.product.id && review) {const badge=document.createElement('div');badge.className='zp-cart-review';const stars=$('img',review);if(stars){const image=stars.cloneNode();image.removeAttribute('style');badge.append(image);}const text=document.createElement('span');text.textContent=review.querySelector('a')?.textContent.trim() || review.textContent.trim();badge.append(text);detail.append(badge);}
      const title=document.createElement('a');title.href=item.url;title.textContent=item.product_title;detail.append(title);
      const variant=data.product.variants.find(v=>v.id===item.variant_id);
      const compare=Math.max(item.original_line_price || 0,(variant?.compare_at_price || 0)*item.quantity);
      const saved=Math.max(0,compare-item.final_line_price);savings+=saved;
      const price=document.createElement('p');price.className='zp-cart-line-price';
      if(saved){const old=document.createElement('s');old.textContent=desktopMoney(compare,cart.currency);price.append(old);}
      const amount=document.createElement('span');amount.textContent=desktopMoney(item.final_line_price,cart.currency);price.append(amount);
      if(saved){const saving=document.createElement('b');saving.textContent='('+labels.save+' '+desktopMoney(saved,cart.currency)+')';price.append(saving);}detail.append(price);
      if (item.variant_title && item.variant_title !== 'Default Title') {const options=document.createElement('p');options.className='zp-cart-options';options.textContent=labels.options+': '+item.variant_title;detail.append(options);}
      if (item.selling_plan_allocation) {const plan=document.createElement('p');plan.textContent=item.selling_plan_allocation.selling_plan.name;detail.append(plan);}
      const controls=document.createElement('div');controls.className='zp-pc-cart-controls';
      const quantity=document.createElement('div');quantity.className='zp-pc-cart-quantity';
      const minus=document.createElement('button');minus.type='button';minus.textContent='−';minus.setAttribute('aria-label',labels.quantity_minus);minus.disabled=cartBusy;minus.addEventListener('click',()=>changeLine(item.key,item.quantity-1));
      const input=document.createElement('input');input.type='number';input.min='0';input.step='1';input.value=String(item.quantity);input.disabled=cartBusy;input.setAttribute('aria-label',labels.quantity+' '+item.product_title);let quantityTimer;
      const commitQuantity=()=>{clearTimeout(quantityTimer);if(!input.isConnected)return;const q=Number(input.value);if(input.value.trim()!==''&&Number.isSafeInteger(q)&&q>=0){if(q!==item.quantity)changeLine(item.key,q);}else input.value=String(item.quantity);};
      input.addEventListener('input',()=>{clearTimeout(quantityTimer);quantityTimer=setTimeout(commitQuantity,350);});input.addEventListener('change',commitQuantity);input.addEventListener('blur',commitQuantity);input.addEventListener('keydown',event=>{if(event.key==='Enter'){event.preventDefault();commitQuantity();}});
      const plus=document.createElement('button');plus.type='button';plus.textContent='+';plus.setAttribute('aria-label',labels.quantity_plus);plus.disabled=cartBusy;plus.addEventListener('click',()=>changeLine(item.key,item.quantity+1));quantity.append(minus,input,plus);
      const remove=document.createElement('button');remove.type='button';remove.className='zp-pc-cart-remove';remove.setAttribute('aria-label',labels.remove+' '+item.product_title);remove.disabled=cartBusy;remove.innerHTML='<svg viewBox="0 0 20 24" width="17" height="18" aria-hidden="true"><path d="M3 7h14M7 7V4h6v3M5 7l1 14h8l1-14M8 10v8m4-8v8" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/></svg>';remove.addEventListener('click',()=>changeLine(item.key,0));controls.append(quantity,remove);detail.append(controls);row.append(detail);content.append(row);
    });
    const saving=$('#zp-cart-savings');saving.replaceChildren();saving.hidden=!savings;const name=document.createElement('span');name.textContent=labels.savings;const amount=document.createElement('b');amount.textContent='−'+desktopMoney(savings,cart.currency);saving.append(name,amount);
    const total=$('#zp-cart-total');total.replaceChildren();if(cart.items.length){const name=document.createElement('span');name.textContent=labels.subtotal;const amount=document.createElement('b');amount.textContent=desktopMoney(cart.total_price,cart.currency,true);total.append(name,amount);}
    const trust=$('.zp-cart-trust');
    if(trust && !trust.querySelector('img')) {const stars=$('.custom_pdp_review img');if(stars){const image=stars.cloneNode();image.removeAttribute('style');image.width=70;image.removeAttribute('height');trust.prepend(image);}}
    $('[data-zp-checkout]').disabled=!cart.items.length || cartBusy;
    $$('[data-draft-count]').forEach(node=>{node.textContent=cart.item_count ? String(cart.item_count) : '';});
  }
  data.cart_heading=$('#zp-cart-heading').textContent;
  desktop.addEventListener('change',()=>{if(lastCart)renderCart(lastCart);});
  async function refreshCart(open = false) {
    const revision = ++cartRevision;
    const mobileOpen=open;
    if (mobileOpen) {showDialog(cartDialog);$('#zp-cart-loading').hidden=false;cartDialog.setAttribute('aria-busy','true');$('[data-zp-checkout]').disabled=true;}
    try {
      const cart = await request('cart.js');
      if (revision === cartRevision) {$('#zp-cart-error').hidden = true;renderCart(cart);}
      if (open) showDialog(cartDialog);
      return cart;
    } catch (error) {if (open) {showDialog(cartDialog);cartError(error);$('[data-zp-checkout]').disabled=true;}throw error;}
    finally {if (revision===cartRevision) {$('#zp-cart-loading').hidden=true;cartDialog.removeAttribute('aria-busy');}}
  }
  async function changeLine(key, quantity) {
    if (cartBusy) return;
    cartBusy = true;++cartRevision;
    $$('button,input', cartDialog).filter(b => !b.hasAttribute('data-zp-close')).forEach(b => {b.disabled = true;});
    try {const cart = await request('cart/change.js', {id: key, quantity});cartBusy = false;$('#zp-cart-error').hidden = true;renderCart(cart);}
    catch (error) {cartBusy = false;await refreshCart().catch(() => {});cartError(error);}
  }
  function initSection(section) {
    if (sectionState.has(section)) return;
    const controller = new AbortController();const options = {signal: controller.signal};
    const on = (node, event, fn, extras = {}) => node?.addEventListener(event, fn, {...options, ...extras});
    const state = {controller};sectionState.set(section, state);
    const counterItems = $$('.zapply-difference-percentage', section).flatMap(node => {
      const original = node.textContent;
      const match = original.match(/^\s*(\d+(?:[.,]\d+)?)\s*%\s*$/);
      if (!match) return [];
      return [{node, original, token: match[1], value: Number(match[1].replace(',', '.')), decimals: (match[1].split(/[.,]/)[1] || '').length}];
    });
    const counterMobile = matchMedia('(max-width: 749px)');
    const counterMotion = matchMedia('(prefers-reduced-motion: reduce)');
    const counterStarted = new Set();
    const counterFrames = new Map();
    let counterObserver;
    const counterText = (item, value) => item.original.replace(item.token, value.toFixed(item.decimals).replace('.', item.token.includes(',') ? ',' : '.'));
    function stopCounters() {
      counterObserver?.disconnect();
      counterObserver = undefined;
      counterFrames.forEach(frame => cancelAnimationFrame(frame));
      counterFrames.clear();
      counterItems.forEach(item => {item.node.textContent = item.original;});
    }
    function animateCounter(item) {
      counterStarted.add(item);
      item.node.textContent = counterText(item, 0);
      const start = performance.now();
      const tick = now => {
        const progress = Math.min(1, (now - start) / 800);
        if (progress >= 1) {
          item.node.textContent = item.original;
          counterFrames.delete(item);
          return;
        }
        item.node.textContent = counterText(item, item.value * (1 - Math.pow(1 - progress, 3)));
        counterFrames.set(item, requestAnimationFrame(tick));
      };
      counterFrames.set(item, requestAnimationFrame(tick));
    }
    function counterMode() {
      stopCounters();
      if (!counterItems.length || !counterMobile.matches || counterMotion.matches || !('IntersectionObserver' in window)) return;
      counterObserver = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (!entry.isIntersecting || entry.intersectionRatio < .35) return;
          const item = counterItems.find(item => item.node === entry.target);
          counterObserver.unobserve(entry.target);
          if (item && !counterStarted.has(item)) animateCounter(item);
        });
      }, {threshold: .35});
      counterItems.forEach(item => {if (!counterStarted.has(item)) counterObserver.observe(item.node);});
    }
    if (counterItems.length) {
      on(counterMobile, 'change', counterMode);
      on(counterMotion, 'change', counterMode);
      state.destroyCounters = stopCounters;
      counterMode();
    }
    const galleryRoot = $('.custom_media-featured-img-container', section);
    const gallery = $$('.custom_media-featured-img-container>img', section);
    const thumbs = $$('[data-zp-thumb]', section);
    const mediaColumn = galleryRoot?.closest('.product__media-wrapper');
    let stickyGalleryObserver, stickyGalleryFrame = 0, stickyGalleryTop;
    function updateStickyGallery() {
      if (!mediaColumn) return;
      if (!desktop.matches) {
        mediaColumn.style.removeProperty('--zp-gallery-top');
        stickyGalleryTop = undefined;
        return;
      }
      const headerHeight = $('[data-zp-header] .draft-header')?.getBoundingClientRect().height || 0;
      const top = headerHeight + 16;
      if (top !== stickyGalleryTop) {
        stickyGalleryTop = top;
        mediaColumn.style.setProperty('--zp-gallery-top', top + 'px');
      }
    }
    const queueStickyGallery = () => {
      if (stickyGalleryFrame) return;
      stickyGalleryFrame = requestAnimationFrame(() => {
        stickyGalleryFrame = 0;
        updateStickyGallery();
      });
    };
    if (mediaColumn) {
      on(desktop, 'change', updateStickyGallery);
      on(window, 'resize', queueStickyGallery);
      if ('ResizeObserver' in window) {
        stickyGalleryObserver = new ResizeObserver(queueStickyGallery);
        const header = $('[data-zp-header] .draft-header');
        if (header) stickyGalleryObserver.observe(header);
      }
      state.destroyStickyGallery = () => {
        stickyGalleryObserver?.disconnect();
        cancelAnimationFrame(stickyGalleryFrame);
        mediaColumn.style.removeProperty('--zp-gallery-top');
      };
      updateStickyGallery();
    }
    const mobileGallery = matchMedia('(max-width: 749px)');
    const galleryMotion = () => matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth';
    let imageIndex = 0, galleryTrack, galleryTimer, galleryObserver, galleryPointer, galleryDragged = false;
    let desktopAnimations=[];
    const galleryOffset = image => image.getBoundingClientRect().left - galleryTrack.getBoundingClientRect().left + galleryTrack.scrollLeft;
    function markImage(index, reveal = true) {
      imageIndex = desktop.matches ? Math.max(0,Math.min(gallery.length-1,index)) : (index + gallery.length) % gallery.length;
      const previous=$('.draft-gallery-prev',section),next=$('.draft-gallery-next',section);if(previous)previous.disabled=desktop.matches&&imageIndex===0;if(next)next.disabled=desktop.matches&&imageIndex===gallery.length-1;
      gallery.forEach((image, i) => image.classList.toggle('is-active', i === imageIndex));
      thumbs.forEach((thumb, i) => {thumb.classList.toggle('is-active', i === imageIndex);thumb.setAttribute('aria-pressed', String(i === imageIndex));});
      const thumb = thumbs[imageIndex], row = thumb?.parentElement;
      if (reveal && thumb && row) {
        if (galleryTrack) {
          const bounds = thumb.getBoundingClientRect(), frame = row.getBoundingClientRect();
          if (bounds.left < frame.left) row.scrollBy({left: bounds.left - frame.left, behavior: galleryMotion()});
          else if (bounds.right > frame.right) row.scrollBy({left: bounds.right - frame.right, behavior: galleryMotion()});
        } else thumb.scrollIntoView({block: 'nearest', inline: 'nearest', behavior: 'smooth'});
      }
    }
    function showImage(index) {
      if (!gallery.length) return;
      if (galleryTrack) {
        const count = gallery.length;
        const target = count > 1 && index < 0 ? galleryTrack.firstElementChild : count > 1 && index >= count ? galleryTrack.lastElementChild : gallery[(index + count) % count];
        markImage(index);
        galleryTrack.scrollTo({left: galleryOffset(target), behavior: galleryMotion()});
      } else {
        desktopAnimations.forEach(animation=>animation.cancel());desktopAnimations=[];
        gallery.forEach(image=>{image.style.display='';image.style.zIndex='';});
        const previous=imageIndex;markImage(index);
        if(desktop.matches && previous!==imageIndex && !matchMedia('(prefers-reduced-motion:reduce)').matches){
          const outgoing=gallery[previous],incoming=gallery[imageIndex],direction=imageIndex>previous?1:-1;
          outgoing.style.display='block';outgoing.style.zIndex='1';incoming.style.zIndex='2';
          const options={duration:300,easing:'ease'};
          desktopAnimations=[outgoing.animate([{transform:'translateX(0)'},{transform:'translateX('+(-direction*100)+'%)'}],options),incoming.animate([{transform:'translateX('+(direction*100)+'%)'},{transform:'translateX(0)'}],options)];
          desktopAnimations[0].onfinish=()=>{outgoing.style.display='';outgoing.style.zIndex='';incoming.style.zIndex='';};
        }
      }
    }
    function settleGallery() {
      clearTimeout(galleryTimer);
      if (!galleryTrack) return;
      const slides = Array.from(galleryTrack.children);
      const left = galleryTrack.getBoundingClientRect().left;
      let nearest = slides[0];
      slides.forEach(slide => {if (Math.abs(slide.getBoundingClientRect().left - left) < Math.abs(nearest.getBoundingClientRect().left - left)) nearest = slide;});
      const index = nearest.hasAttribute('data-zp-gallery-clone') ? Number(nearest.dataset.zpGalleryClone) : gallery.indexOf(nearest);
      markImage(index);
      if (nearest.hasAttribute('data-zp-gallery-clone')) galleryTrack.scrollTo({left: galleryOffset(gallery[index]), behavior: 'instant'});
    }
    function restoreGallery() {
      clearTimeout(galleryTimer);
      galleryObserver?.disconnect();
      galleryObserver = undefined;
      if (!galleryTrack) return;
      gallery.forEach(image => galleryRoot.insertBefore(image, galleryTrack));
      galleryTrack.remove();
      galleryTrack = undefined;
      markImage(imageIndex, false);
    }
    function galleryMode() {
      if (!galleryRoot || !gallery.length) return;
      if (!mobileGallery.matches) {restoreGallery();markImage(imageIndex,false);return;}
      if (galleryTrack) return;
      galleryTrack = document.createElement('div');
      galleryTrack.className = 'zp-gallery-track';
      galleryTrack.tabIndex = 0;
      const cloneImage = index => {
        const clone = gallery[index].cloneNode(true);
        clone.removeAttribute('id');
        clone.setAttribute('aria-hidden', 'true');
        clone.setAttribute('inert', '');
        clone.dataset.zpGalleryClone = String(index);
        return clone;
      };
      if (gallery.length > 1) galleryTrack.append(cloneImage(gallery.length - 1));
      gallery.forEach(image => galleryTrack.append(image));
      if (gallery.length > 1) galleryTrack.append(cloneImage(0));
      galleryRoot.prepend(galleryTrack);
      galleryTrack.scrollTo({left: galleryOffset(gallery[imageIndex]), behavior: 'instant'});
      on(galleryTrack, 'scroll', () => {clearTimeout(galleryTimer);galleryTimer = setTimeout(settleGallery, 180);}, {passive: true});
      on(galleryTrack, 'scrollend', settleGallery);
      on(galleryTrack, 'pointerdown', event => {galleryPointer = {x: event.clientX, y: event.clientY};galleryDragged = false;}, {passive: true});
      on(galleryTrack, 'pointermove', event => {if (galleryPointer && Math.hypot(event.clientX - galleryPointer.x, event.clientY - galleryPointer.y) > 10) galleryDragged = true;}, {passive: true});
      on(galleryTrack, 'pointercancel', () => {galleryDragged = true;galleryPointer = undefined;}, {passive: true});
      on(galleryTrack, 'pointerup', () => {galleryPointer = undefined;}, {passive: true});
      on(galleryTrack, 'click', event => {if (galleryDragged) {event.preventDefault();event.stopImmediatePropagation();}}, {capture: true});
      on(galleryTrack, 'keydown', event => {
        if (!['ArrowLeft', 'ArrowRight', 'Pradžia', 'End'].includes(event.key)) return;
        event.preventDefault();
        showImage(event.key === 'Pradžia' ? 0 : event.key === 'End' ? gallery.length - 1 : imageIndex + (event.key === 'ArrowRight' ? 1 : -1));
      });
      let galleryWidth = galleryTrack.getBoundingClientRect().width;
      galleryObserver = new ResizeObserver(() => {
        if (!galleryTrack) return;
        const width = galleryTrack.getBoundingClientRect().width;
        if (Math.abs(width - galleryWidth) < .5) return;
        galleryWidth = width;
        clearTimeout(galleryTimer);
        galleryTrack.scrollTo({left: galleryOffset(gallery[imageIndex]), behavior: 'instant'});
      });
      galleryObserver.observe(galleryTrack);
    }
    thumbs.forEach((thumb, i) => on(thumb, 'click', () => showImage(i)));
    on($('.draft-gallery-prev', section), 'click', () => showImage(imageIndex - 1));
    on($('.draft-gallery-next', section), 'click', () => showImage(imageIndex + 1));
    let touchX;
    on(galleryRoot, 'touchstart', event => {if (!galleryTrack) touchX = event.changedTouches[0].clientX;}, {passive: true});
    on(galleryRoot, 'touchend', event => {if (galleryTrack) return;const delta = event.changedTouches[0].clientX - touchX;if (Math.abs(delta) > 45) showImage(imageIndex + (delta < 0 ? 1 : -1));}, {passive: true});
    gallery.forEach(image => {image.style.cursor = 'zoom-in';on(image, 'click', () => {if (mobileGallery.matches) return;$('#zp-modal-image').src = image.currentSrc || image.src;$('#zp-modal-image').alt = image.alt;showDialog($('#zp-image-dialog'));});});
    on(mobileGallery, 'change', galleryMode);
    state.destroyGallery = restoreGallery;
    if (gallery.length) {markImage(0, false);galleryMode();}
    $$('.buy_box_fp_accordian-item', section).forEach((item, i) => {
      const button = $('.buy_box_fp_accordian-question', item), answer = $('.buy_box_fp_accordian-answer', item);
      if (!button || !answer) return;
      answer.id = section.dataset.zpSection + '-answer-' + i;button.type = 'button';button.setAttribute('aria-controls', answer.id);
      const setAnswerOpen = open => {
        item.classList.toggle('is-open', open);
        button.setAttribute('aria-expanded', String(open));
        answer.inert = !open;
        answer.style.maxHeight = open ? (answer.scrollHeight + 20) + 'px' : '0px';
      };
      setAnswerOpen(i === 0);
      on(button, 'click', () => setAnswerOpen(!item.classList.contains('is-open')));
      on(window, 'resize', () => {if (item.classList.contains('is-open')) setAnswerOpen(true);});
    });
    $$('.trigger-popup', section).forEach(link => on(link, 'click', event => {event.preventDefault();const image = $('img', link);$('#zp-modal-image').src = image?.src || link.dataset.image;$('#zp-modal-image').alt = image?.alt || link.textContent.trim();showDialog($('#zp-image-dialog'));}));
    const tabs = $$('.ingredients-tabs__btn', section), panels = $$('.ingredients-panel', section);
    const ingredientsRoot = $('.ingredients-panels', section);
    const mobileIngredients = matchMedia('(max-width: 749px)');
    const tabControls = tabs.map(tab => tab.getAttribute('aria-controls'));
    const ingredientHomes = panels.flatMap((panel, category) => $$('.ingredient-card', panel).map(card => ({card, category, home: card.parentElement})));
    let ingredientTrack;
    let ingredientCategory = 0;
    let ingredientScrollFrame;
    let ingredientWheelTimer;
    const selectIngredientTab = (index) => {
      ingredientCategory = index;
      tabs.forEach((tab, i) => {tab.setAttribute('aria-selected', String(i === index));tab.tabIndex = i === index ? 0 : -1;});
      if (ingredientTrack) {
        ingredientTrack.setAttribute('aria-labelledby', tabs[index].id);

      }
    };
    const ingredientOffset = card => card.getBoundingClientRect().left - ingredientTrack.getBoundingClientRect().left + ingredientTrack.scrollLeft - ingredientTrack.clientLeft;
    const showTab = index => {
      selectIngredientTab(index);
      if (ingredientTrack) {
        const first = ingredientHomes.find(item => item.category === index);
        if (first) ingredientTrack.scrollTo({left: ingredientOffset(first.card), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
        return;
      }
      panels.forEach((panel, i) => {panel.hidden = i !== index;panel.classList.toggle('is-active', i === index);});
    };
    const followIngredients = () => {
      ingredientScrollFrame = undefined;
      if (!ingredientTrack || !ingredientHomes.length) return;
      if (ingredientTrack.scrollLeft >= ingredientTrack.scrollWidth - ingredientTrack.clientWidth - 2) {
        selectIngredientTab(ingredientHomes[ingredientHomes.length - 1].category);
        return;
      }
      const left = ingredientTrack.getBoundingClientRect().left;
      const nearest = ingredientHomes.reduce((current, item) => Math.abs(item.card.getBoundingClientRect().left - left) < Math.abs(current.card.getBoundingClientRect().left - left) ? item : current);
      selectIngredientTab(nearest.category);
    };
    const restoreIngredients = () => {
      if (ingredientScrollFrame) cancelAnimationFrame(ingredientScrollFrame);
      clearTimeout(ingredientWheelTimer);
      ingredientHomes.forEach(item => item.home.append(item.card));
      ingredientTrack?.remove();
      ingredientTrack = undefined;
      ingredientsRoot?.removeAttribute('data-mobile-ingredients');
      tabs.forEach((tab, index) => tab.setAttribute('aria-controls', tabControls[index]));
    };
    const ingredientMode = () => {
      if (!ingredientsRoot || !tabs.length) return;
      if (ingredientTrack) return;
      ingredientTrack = document.createElement('div');
      ingredientTrack.className = 'zp-mobile-ingredients-track zp-ingredients-track';
      ingredientTrack.id = section.dataset.zpSection + '-ingredients-track';
      ingredientTrack.setAttribute('role', 'tabpanel');
      ingredientTrack.tabIndex = 0;
      ingredientsRoot.dataset.mobileIngredients = '';
      panels.forEach(panel => {panel.hidden = true;panel.classList.remove('is-active');});
      ingredientHomes.forEach(item => ingredientTrack.append(item.card));
      ingredientsRoot.append(ingredientTrack);
      tabs.forEach(tab => tab.setAttribute('aria-controls', ingredientTrack.id));
      on(ingredientTrack, 'scroll', () => {
        if (!ingredientScrollFrame) ingredientScrollFrame = requestAnimationFrame(followIngredients);
      }, {passive: true});
      on(ingredientTrack, 'keydown', event => {
        if (!['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
        event.preventDefault();
        const width = ingredientHomes[0]?.card.offsetWidth || ingredientTrack.clientWidth;
        ingredientTrack.scrollBy({left: (event.key === 'ArrowLeft' ? -1 : 1) * (width + parseFloat(getComputedStyle(ingredientTrack).columnGap || 0)), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      });
      let ingredientDrag;
      on(ingredientTrack, 'pointerdown', event => {
        if (mobileIngredients.matches || event.pointerType !== 'mouse' || event.button !== 0 || event.target.closest('a,button,input')) return;
        ingredientDrag = {x: event.clientX, left: ingredientTrack.scrollLeft, moved: false};
        ingredientTrack.setPointerCapture(event.pointerId);
      });
      on(ingredientTrack, 'pointermove', event => {
        if (!ingredientDrag) return;
        const delta = event.clientX - ingredientDrag.x;
        if (!ingredientDrag.moved && Math.abs(delta) < 5) return;
        ingredientDrag.moved = true;
        ingredientTrack.classList.add('is-dragging');
        event.preventDefault();
        ingredientTrack.scrollLeft = ingredientDrag.left - delta;
      });
      const finishIngredientDrag = () => {
        ingredientDrag = undefined;
        ingredientTrack.classList.remove('is-dragging');
      };
      on(ingredientTrack, 'pointerup', finishIngredientDrag);
      on(ingredientTrack, 'pointercancel', finishIngredientDrag);
      on(ingredientTrack, 'lostpointercapture', finishIngredientDrag);
      on(ingredientTrack, 'dragstart', event => event.preventDefault());
      on(ingredientTrack, 'wheel', event => {
        if (mobileIngredients.matches || event.ctrlKey || event.shiftKey || Math.abs(event.deltaX) > Math.abs(event.deltaY) || !event.deltaY) return;
        const limit = ingredientTrack.scrollWidth - ingredientTrack.clientWidth;
        if ((event.deltaY < 0 && ingredientTrack.scrollLeft <= 1) || (event.deltaY > 0 && ingredientTrack.scrollLeft >= limit - 1)) return;
        event.preventDefault();
        ingredientTrack.classList.add('is-wheel-scrolling');
        const delta = event.deltaY * (event.deltaMode === 1 ? 16 : event.deltaMode === 2 ? ingredientTrack.clientWidth : 1);
        ingredientTrack.scrollLeft += delta;
        clearTimeout(ingredientWheelTimer);
        ingredientWheelTimer = setTimeout(() => ingredientTrack?.classList.remove('is-wheel-scrolling'), 180);
      }, {passive: false});
      const first = ingredientHomes.find(item => item.category === ingredientCategory);
      if (first) ingredientTrack.scrollTo({left: ingredientOffset(first.card), behavior: 'instant'});
      selectIngredientTab(ingredientCategory);
    };
    tabs.forEach((tab, i) => {on(tab, 'click', () => showTab(i));on(tab, 'keydown', event => {const next = {ArrowRight: (i + 1) % tabs.length, ArrowLeft: (i + tabs.length - 1) % tabs.length, Home: 0, End: tabs.length - 1}[event.key];if (next !== undefined) {event.preventDefault();tabs[next].focus();showTab(next);}});});
    on(mobileIngredients, 'change', () => showTab(ingredientCategory));
    on(section, 'shopify:block:select', event => {
      const card = event.target.closest('.ingredient-card');
      if (!ingredientTrack || !card) return;
      const item = ingredientHomes.find(entry => entry.card === card);
      if (!item) return;
      event.stopImmediatePropagation();
      selectIngredientTab(item.category);
      ingredientTrack.scrollTo({left: ingredientOffset(card), behavior: 'instant'});
    });
    state.destroyIngredients = restoreIngredients;
    if (tabs.length) {showTab(0);ingredientMode();}
    $('.ingredients-section', section)?.classList.add('is-visible');
    $$('.hof-nav', section).forEach(button => on(button, 'click', () => {const track = $('.hof-swiper', section);track?.scrollBy({left: (button.classList.contains('hof-nav--prev') ? -1 : 1) * (track.clientWidth / 3 + 10), behavior: 'smooth'});}));
    const reviewTrack = $('.draft-reviews-track', section);
    if (reviewTrack) {
      const mobileReviews = matchMedia('(max-width: 749px)');
      const reviewButtons = $$('.draft-reviews-prev,.draft-reviews-next', section);
      let reviews = [];
      let reviewTimer;
      let reviewIndex = 0;
      const removeClones = () => $$('[data-review-clone]', reviewTrack).forEach(card => card.remove());
      const reviewStep = () => {
        const cards = $$('.draft-review', reviewTrack);
        return cards.length > 1 ? cards[1].offsetLeft - cards[0].offsetLeft : reviewTrack.clientWidth;
      };
      const positionReview = (index, behavior = 'instant') => {
        const count = reviews.length;
        if (!count) return;
        reviewIndex = ((index % count) + count) % count;
        const physicalIndex = count > 1 ? count + reviewIndex : 0;
        reviewTrack.scrollTo({left: physicalIndex * reviewStep(), behavior});
      };
      const settleReview = () => {
        if (!mobileReviews.matches || !reviews.length) return;
        const step = reviewStep();
        if (!step) return;
        const physicalIndex = Math.round(reviewTrack.scrollLeft / step);
        const count = reviews.length;
        reviewIndex = ((physicalIndex - count) % count + count) % count;
        if (count > 1 && (physicalIndex < count || physicalIndex >= count * 2)) positionReview(reviewIndex);
      };
      const cloneReview = card => {
        const clone = card.cloneNode(true);
        clone.dataset.reviewClone = '';
        clone.setAttribute('aria-hidden', 'true');
        clone.setAttribute('inert', '');
        [clone, ...clone.querySelectorAll('*')].forEach(node => {
          node.removeAttribute('id');
          node.removeAttribute('data-zp-block');
          node.removeAttribute('data-shopify-editor-block');
          node.removeAttribute('data-shopify-editor-block-id');
        });
        return clone;
      };
      const buildReviews = () => {
        clearTimeout(reviewTimer);
        removeClones();
        reviews = $$('.draft-review', reviewTrack);
        reviewButtons.forEach(button => {button.hidden = mobileReviews.matches && reviews.length < 2;});
        if (!mobileReviews.matches) {reviewTrack.scrollLeft = 0;return;}
        if (reviews.length > 1) {
          reviewTrack.prepend(...reviews.map(cloneReview));
          reviewTrack.append(...reviews.map(cloneReview));
        }
        positionReview(reviewIndex);
      };
      on(mobileReviews, 'change', buildReviews);
      on(window, 'resize', () => {if (mobileReviews.matches) positionReview(reviewIndex);});
      on(reviewTrack, 'scroll', () => {
        if (!mobileReviews.matches) return;
        clearTimeout(reviewTimer);
        reviewTimer = setTimeout(settleReview, 160);
      }, {passive: true});
      on(reviewTrack, 'scrollend', settleReview);
      on(reviewTrack, 'keydown', event => {
        if (!mobileReviews.matches || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
        event.preventDefault();
        const direction = event.key === 'ArrowLeft' ? -1 : 1;
        const target = Math.round(reviewTrack.scrollLeft / reviewStep()) + direction;
        reviewTrack.scrollTo({left: target * reviewStep(), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      });
      reviewButtons.forEach(button => on(button, 'click', () => {
        const direction = button.classList.contains('draft-reviews-prev') ? -1 : 1;
        if (!mobileReviews.matches) {reviewTrack.scrollBy({left: direction * reviewTrack.clientWidth, behavior: 'smooth'});return;}
        const target = Math.round(reviewTrack.scrollLeft / reviewStep()) + direction;
        reviewTrack.scrollTo({left: target * reviewStep(), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      }));
      on(section, 'shopify:block:select', event => {
        const card = event.target.closest('.draft-review');
        if (mobileReviews.matches && card && reviews.includes(card)) {
          event.stopImmediatePropagation();
          positionReview(reviews.indexOf(card));
        }
      });
      state.destroyReviews = () => {clearTimeout(reviewTimer);removeClones();};
      buildReviews();
    }
    const announcement=$('.zp-pc-announcement-track',section);
    if(announcement){const resize=new ResizeObserver(()=>announcement.style.setProperty('--zp-pc-announcement-duration',(announcement.scrollWidth/2/56.72)+'s'));resize.observe(announcement);state.destroyAnnouncement=()=>resize.disconnect();}
    const menu = $('.draft-menu-toggle', section), nav = $('.draft-nav', section);
    if (section.hasAttribute('data-zp-header') && !menu) {
      const mobileHeader = matchMedia('(max-width:749px)');
      const header = $('.draft-header', section);
      const host = section.closest('.shopify-section') || section;
      const logo = $('.draft-logo', section);
      const originalLogoHref = logo?.getAttribute('href');
      const bar = $('.draft-announcement', section);
      const updateHeader = () => {
        host.classList.toggle('zp-mobile-header-host', mobileHeader.matches);
        host.style.setProperty('--zp-announcement-height', `${bar?.offsetHeight || 0}px`);
        if (logo) logo.setAttribute('href', mobileHeader.matches ? logo.dataset.mobileHome : originalLogoHref);
      };
      on(mobileHeader, 'change', updateHeader);
      const headerObserver = new ResizeObserver(updateHeader);
      headerObserver.observe(header);
      if (bar) headerObserver.observe(bar);
      state.destroyHeader = () => {headerObserver.disconnect();host.classList.remove('zp-mobile-header-host');host.style.removeProperty('--zp-announcement-height');if (logo) logo.setAttribute('href', originalLogoHref);};
      updateHeader();
    } else if (section.hasAttribute('data-zp-header') && menu && nav) {
      const mobileHeader = matchMedia('(max-width:749px)');
      const header = $('.draft-header', section);
      const host = section.closest('.shopify-section') || section;
      const backdrop = $('.zp-menu-backdrop', section);
      const logo = $('.draft-logo', section);
      const originalLogoHref = logo?.getAttribute('href');
      const openLabel = menu.getAttribute('aria-label');
      const inertNodes = new Map();
      let previousOverflow;
      let locked = false;
      const updateHeader = () => {
        if (!mobileHeader.matches) return;
        const bar = $('.draft-announcement', section);
        host.style.setProperty('--zp-announcement-height', `${bar?.offsetHeight || 0}px`);
        section.style.setProperty('--zp-menu-top', `${Math.max(0,header.getBoundingClientRect().bottom)}px`);
      };
      const restorePage = () => {
        inertNodes.forEach((previous,node) => {node.inert=previous;});inertNodes.clear();
        if (locked) {document.body.style.overflow=previousOverflow;locked=false;}
      };
      const closeMenu = (focus = false) => {
        nav.classList.remove('is-open');menu.setAttribute('aria-expanded','false');menu.setAttribute('aria-label',openLabel);
        header.removeAttribute('role');header.removeAttribute('aria-modal');header.removeAttribute('aria-label');nav.inert=mobileHeader.matches;
        backdrop.hidden=true;restorePage();
        if (focus) menu.focus();
      };
      const openMenu = () => {
        updateHeader();nav.inert=false;nav.classList.add('is-open');header.setAttribute('role','dialog');header.setAttribute('aria-modal','true');header.setAttribute('aria-label',nav.getAttribute('aria-label'));
        menu.setAttribute('aria-expanded','true');menu.setAttribute('aria-label',menu.dataset.closeLabel);backdrop.hidden=false;
        previousOverflow=document.body.style.overflow;document.body.style.overflow='hidden';locked=true;
        Array.from($('#MainContent').children).filter(node=>node instanceof HTMLElement && !node.contains(section)).forEach(node=>{inertNodes.set(node,node.inert);node.inert=true;});
        $('a[href]',nav)?.focus();
      };
      const headerMode = () => {
        closeMenu();host.classList.toggle('zp-mobile-header-host',mobileHeader.matches);
        if (logo) logo.setAttribute('href',mobileHeader.matches ? logo.dataset.mobileHome : originalLogoHref);
        updateHeader();
      };
      on(menu,'click',()=>{
        if (mobileHeader.matches) {nav.classList.contains('is-open') ? closeMenu(true) : openMenu();}
        else {menu.setAttribute('aria-expanded',String(nav.classList.toggle('is-open')));}
      });
      on(backdrop,'click',()=>closeMenu(true));
      $$('a',nav).forEach(link=>on(link,'click',()=>closeMenu()));
      on(document,'click',event=>{if (event.target.closest('[data-zp-cart]')) closeMenu();});
      on(document,'keydown',event=>{
        if (!mobileHeader.matches || !nav.classList.contains('is-open')) return;
        if (event.key==='Escape') {event.preventDefault();closeMenu(true);return;}
        if (event.key!=='Tab') return;
        const focusable=[menu,logo,...$$('a[href]',nav),$('[data-zp-cart]',section)].filter(Boolean);
        const index=focusable.indexOf(document.activeElement);
        event.preventDefault();focusable[(index+(event.shiftKey?-1:1)+focusable.length)%focusable.length]?.focus();
      });
      on(mobileHeader,'change',headerMode);on(window,'scroll',updateHeader,{passive:true});
      const headerObserver=new ResizeObserver(updateHeader);headerObserver.observe(header);
      const bar=$('.draft-announcement',section);if (bar) headerObserver.observe(bar);
      state.destroyHeader=()=>{closeMenu();headerObserver.disconnect();host.classList.remove('zp-mobile-header-host');host.style.removeProperty('--zp-announcement-height');section.style.removeProperty('--zp-menu-top');nav.inert=false;if(logo)logo.setAttribute('href',originalLogoHref);};
      headerMode();
    } else {
      on(menu, 'click', () => {menu.setAttribute('aria-expanded', String(nav.classList.toggle('is-open')));});
      $$('.draft-nav a', section).forEach(link => on(link, 'click', () => {nav.classList.remove('is-open');menu?.setAttribute('aria-expanded', 'false');}));
    }
    const services = $('.draft-services-track', section);
    on($('[data-service-prev]', section), 'click', () => services?.scrollBy({left: -services.clientWidth, behavior: 'smooth'}));
    on($('[data-service-next]', section), 'click', () => services?.scrollBy({left: services.clientWidth, behavior: 'smooth'}));
    const servicePosition = () => {const count = $$('.draft-service', section).length;const position = Math.min(count, Math.round(services.scrollLeft / (services.clientWidth || 1)) + 1);const output = $('[data-service-position]', section);if (output) output.textContent = position + ' / ' + count;};
    on(services, 'scroll', servicePosition, {passive: true});if (services) servicePosition();
    const form = $('[data-zp-product-form]', section), variantData = $('[data-zp-variants]', section);
    if (form && variantData) {
      const variants = JSON.parse(variantData.textContent), choice = $$('[data-zp-choice]', section), plan = $('[data-zp-plan]', form), id = $('[data-zp-variant]', form), submit = $('[data-zp-submit]', form);
      let pending = false;
      function current() {return variants.find(variant => String(variant.id) === String(id.value));}
      function updateVariant() {
        const checked = choice.find(radio => radio.checked);if (checked) id.value = checked.value;
        const variant = current();if (!variant) return;
        if (plan) {
          Array.from(plan.options).forEach(option => {option.disabled = Boolean(option.value) && !variant.plans.some(allocation => String(allocation.id) === option.value);});
          if (plan.selectedOptions[0]?.disabled) plan.value = variant.requires_plan ? String(variant.plans[0]?.id || '') : '';
        }
        const selectedPlan = plan?.value || '';
        const allocation = variant.plans.find(entry => String(entry.id) === selectedPlan);
        const purchasable = variant.available && (!variant.requires_plan || allocation) && (!selectedPlan || allocation);
        submit.disabled = pending || !purchasable;submit.textContent = purchasable ? submit.dataset.label : labels.sold_out;
        $$('[data-zp-quick-add]', section).forEach(button => {button.disabled = submit.disabled;});
        $$('[data-zp-sticky-price]', section).forEach(node => {node.textContent = allocation?.formatted || variant.formatted;});
        $$('[data-zp-card-price]', section).forEach(node => {const entry = variants.find(v => String(v.id) === node.dataset.zpCardPrice);const match = entry?.plans.find(p => String(p.id) === selectedPlan);node.textContent = match?.formatted || entry?.formatted || '';});
      }
      choice.forEach(radio => on(radio, 'change', () => {updateVariant();const url = new URL(location.href);url.searchParams.set('variant', id.value);history.replaceState({}, '', url);}));
      on(plan, 'change', updateVariant);
      on(form, 'submit', async event => {
        event.preventDefault();if (pending || submit.disabled || !form.reportValidity()) return;
        const quantity = Number(form.elements.quantity.value);if (!Number.isInteger(quantity) || quantity < 1) return;
        const variant = current();if (!variant?.available) return;
        const payload = {id: variant.id, quantity};if (plan?.value) payload.selling_plan = Number(plan.value);
        pending = true;updateVariant();const errorNode = $('[data-zp-form-error]', form);errorNode.hidden = true;
        try {
          await request('cart/add.js', {items: [payload]});
          announce(labels.added);
          await refreshCart(true).catch(error => cartError(error));
        } catch (error) {errorNode.textContent = error.message || labels.error;errorNode.hidden = false;}
        finally {pending = false;updateVariant();}
      });
      $$('[data-zp-quick-add]', section).forEach(button => on(button, 'click', () => form.requestSubmit()));
      updateVariant();
    }
    on(section, 'shopify:block:select', event => {
      const block = event.target.closest('[data-zp-block]');
      const panel = block?.closest('.ingredients-panel');if (panel) showTab(panels.indexOf(panel));
      const details = block?.closest('details');if (details) details.open = true;
      block?.scrollIntoView({block: 'center', inline: 'center', behavior: 'smooth'});
    });
    state.scroll = () => {
      const sticky = $('[data-zp-sticky]', section);
      const purchase = $('[data-zp-product-form]', section);
      sticky?.classList.toggle('is-visible', !!purchase && purchase.getBoundingClientRect().bottom < 0);
      updateStickyGallery();
      const track = $('[data-tlp-track]', section);if (!track) return;
      const bounds = track.getBoundingClientRect(), progress = Math.max(0, Math.min(1, (innerHeight * .65 - bounds.top) / (bounds.height + innerHeight * .3)));
      const fill = $('[data-tlp-fill]', section);if (fill) fill.style.height = progress * 100 + '%';
      $$('[data-tlp-item]', section).forEach(item => item.classList.toggle('is-active', progress * bounds.height >= item.getBoundingClientRect().top + 32 - bounds.top));
      const stages = $$('[data-tlp-stage]', section);stages.forEach((stage, i) => stage.classList.toggle('is-active', i === Math.min(stages.length - 1, Math.floor(progress * stages.length))));
      $$('[data-tlp-figure],[data-tlp-figure-mobile]', section).forEach(figure => {figure.style.top = progress * bounds.height - figure.offsetHeight / 2 + 'px';});
      const percent = $('[data-tlp-pct]', section);if (percent) percent.textContent = Math.round(progress * 100);
    };
    state.scroll();
  }
  function init(parent = document) {if (parent.matches?.('[data-zp-section]')) initSection(parent);$$('[data-zp-section]', parent).forEach(initSection);}
  document.addEventListener('click', event => {
    if (event.target.closest('[data-zp-cart]')) refreshCart(true).catch(() => {});
    if (event.target.closest('[data-zp-search]')) {if(desktop.matches){const dialog=$('#zp-search-dialog');const header=$('.draft-header');dialog.style.top=Math.max(0,header.getBoundingClientRect().top)+'px';showDialog(dialog);$('#zp-search-input').focus();}else location.assign(data.search_url);}
    const close = event.target.closest('[data-zp-close]');close?.closest('dialog')?.close();
  });
  $$('dialog').forEach(dialog => dialog.addEventListener('click', event => {if (event.target === dialog) {const bounds = dialog.getBoundingClientRect();if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();}}));
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => {$$('[data-zp-section]', event.target).forEach(section => {sectionState.get(section)?.destroyAnnouncement?.();sectionState.get(section)?.destroyHeader?.();sectionState.get(section)?.destroyCounters?.();sectionState.get(section)?.destroyGallery?.();sectionState.get(section)?.destroyStickyGallery?.();sectionState.get(section)?.destroyIngredients?.();sectionState.get(section)?.destroyReviews?.();sectionState.get(section)?.controller.abort();sectionState.delete(section);});});
  let queued = false;
  const scroll = () => {if (queued) return;queued = true;requestAnimationFrame(() => {queued = false;$$('[data-zp-section]').forEach(section => sectionState.get(section)?.scroll());});};
  window.addEventListener('scroll', scroll, {passive: true});window.addEventListener('resize', scroll);
  init();refreshCart().catch(() => {});
})();
